var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"signUp_banner"}},[_c('img',{attrs:{"src":_vm.bannerSrc,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }